import { makeStyles } from "@saleor/macaw-ui";

interface propsType {
  sidebarWidth?: number;
  expanded?: boolean;
  fullScreen?: boolean;
}

const useStyles = makeStyles<propsType>(
  theme => ({
    root: {
      display: props => (props.fullScreen ? "none" : "block"),
      transition: "width 0.5s ease",
      width: props => props.sidebarWidth,
      whiteSpace: "nowrap"
    },
    float: {
      transition: "width 0.5s ease",
      width: props => props.sidebarWidth,
      height: "100vh",
      position: "fixed",
      overflowY: "auto",
      overflowX: "hidden",
      background: "#FFF",
      display: "flex",
      flexDirection: "column"
    },
    floatButton: {
      width: 20,
      height: 20,
      minWidth: "unset",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#FFFFFF",
      boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.16)",
      position: "fixed",
      top: props => (props.expanded ? 87 : 107),
      marginLeft: props => (props.expanded ? "25rem" : "9.4rem"),
      zIndex: 10,
      cursor: "pointer",
      userSelect: "none",
      "&:hover": {
        boxShadow:
          "0px 2px 2px rgba(0, 0, 0, 0.16), 0px 0px 0px 3px rgba(1, 178, 237, 0.24)"
      },
      "& svg.MuiSvgIcon-root": {
        marginRight: "unset",
        fontSize: "10.5px"
      }
    },
    rootMenuItem: { position: "relative" },
    chipMenuItem: {
      position: "absolute",
      bottom: "68%",
      right: "-18px",
      zIndex: 1,
      background: theme.palette.scgPrimary.main,
      border: "2.5px solid #FFFFFF",
      borderRadius: 12,
      padding: "5px 8px",

      "& .MuiChip-label": {
        padding: 0,
        color: "#ffffff",
        fontSize: 16,
        fontWeight: 700
      }
    },
    svgIcon: {
      fill: theme.palette.grey[500],
      fontSize: ".75em"
    },
    logosContainer: {
      padding: props => (props.expanded ? "20px 10px" : "32px 36px 31px"),
      transition: "all 0.5s ease",
      borderBottom: `solid 1px ${theme.palette.grey[200]}`,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      "&:hover": {
        // Override borderBottom Button tag
        borderBottom: `solid 1px ${theme.palette.grey[200]}`
      }
    },
    logoScgp: {
      display: props => (props.expanded ? "block" : "none"),
      paddingRight: 20,
      paddingLeft: 12,
      height: 12.5
    },
    logoPipe: {
      display: props => (props.expanded ? "block" : "none"),
      width: "0.63px",
      height: 35,
      borderRight: `solid 1px ${theme.palette.error.main}`,
      marginRight: 20
    },
    logoRightBox: {
      display: "flex",
      alignItems: "center"
    },
    logoE: {
      width: props => (props.expanded ? 40 : 32),
      height: props => (props.expanded ? 40 : 36)
    },
    logoOrdering: {
      display: props => (props.expanded ? "block" : "none"),
      marginLeft: 10,
      height: 20
    },
    menuContainer: {
      marginTop: props => (props.expanded ? 20 : 32),
      padding: "0 24px",
      userSelect: "none"
    },
    menuItem: {
      display: "flex",
      alignItems: "center",
      color: theme.palette.purple.main,
      padding: props => (props.expanded ? 15 : "12px 18px"),
      borderRadius: 4,
      marginBottom: 16,
      cursor: "pointer",
      transition: "background 0.2s ease",
      "&.active": {
        background: theme.palette.gardient.default,
        color: "#FFF",
        "&:hover": {
          background: theme.palette.gardient.hover
        }
      },
      "&:hover": {
        background: "#F4F7FE"
      },
      "& svg": {
        maxWidth: "20px"
      },
      minWidth: "52px",
      width: "100%",
      justifyContent: props => (props.expanded ? "left" : "center")
    },
    subLabel: {
      position: "relative",
      fontWeight: "bold",
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginTop: "-10px"
    },
    menuIcon: {},
    menuLabel: {
      display: props => (props.expanded ? "block" : "none"),
      marginLeft: 15,
      fontSize: 18,
      transition: "all 0.2s ease",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    paperMenu: {
      padding: "0px",
      borderRadius: "8px"
    },
    parentMenu: {
      padding: "8px 0px",
      borderRadius: "8px"
    },
    childrenMenu: {
      padding: "5px 12px 5px 12px",
      fontFamily: "ScgFont",
      color: `${theme.palette.grey[900]} !important`,
      justifyContent: "flex-start !important",
      "&:hover": {
        color: "#007E92 !important"
      },
      minHeight: "34px",
      fontSize: "16px !important",
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "4px"
    },
    signOutButton: {
      color: theme.palette.purple.main,
      display: "flex",
      alignItems: "center",
      padding: "0 35px",
      marginTop: "auto",
      marginBottom: 20,
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline"
      }
    },
    signOutText: {
      marginLeft: 15,
      fontSize: 16,
      display: props => (props.expanded ? "block" : "none")
    },
    chipClass: {
      bottom: "68%",
      right: "-18px"
    }
  }),
  { name: "Sidebar" }
);

export default useStyles;
